import { useRecipientResolution } from 'hooks/useRecipientResolution'
import { useTranslation } from 'react-i18next'

const useMeetingRecipients = (
  primaryRecipientId = null,
  additionalRecipientIds = []
) => {
  const { t } = useTranslation()
  const { recipient: primaryRecipient } = useRecipientResolution(primaryRecipientId)

  if (!primaryRecipient.id) {
    return ''
  }

  return !!additionalRecipientIds.length
    ? t('meeting.recipients', {
        name: primaryRecipient.name,
        others: additionalRecipientIds.length
      })
    : `${primaryRecipient.name}`

}

export default useMeetingRecipients
